"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Chip = _interopRequireDefault(require("@mui/material/Chip/Chip.js"));

var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles/makeStyles.js"));

var _Colors = _interopRequireDefault(require("../../styles/Colors"));

var _excluded = ["deleteIconWrapper", "chipWrapper"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyle = (0, _makeStyles.default)({
  root: {
    backgroundColor: function backgroundColor(props) {
      return props.disabled ? "".concat(_Colors.default.lightGrey, "80") : props.color;
    },
    '&.Mui-disabled': {
      opacity: 1
    },
    '&:focus': {
      backgroundColor: function backgroundColor(props) {
        return props.disabled ? _Colors.default.lightGrey : props.color;
      }
    },
    '&:hover': {
      backgroundColor: function backgroundColor(props) {
        return props.color;
      }
    }
  },
  disabled: {},
  // Disabled is a MUI pseudo-class. Refer to the documentation.
  label: {
    fontWeight: function fontWeight(props) {
      return props.size === 'small' ? 'bold' : 'normal';
    },
    fontFamily: 'Lato',
    fontSize: 13,
    color: function color(props) {
      return props.disabled ? _Colors.default.secondaryGrey : _Colors.default.white;
    },
    lineHeight: '18px',
    padding: '0 12px'
  },
  chipWrapper: function chipWrapper(_ref) {
    var width = _ref.width,
        margin = _ref.margin;
    return {
      width: width,
      margin: margin
    };
  },
  deleteIconWrapper: {
    width: '20px',
    height: '20px'
  }
});

var Chip = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var id = props.id,
      label = props.label,
      onClick = props.onClick,
      onDelete = props.onDelete,
      _props$color = props.color,
      color = _props$color === void 0 ? _Colors.default.acceptGreen : _props$color,
      disabled = props.disabled,
      deleteIcon = props.deleteIcon,
      className = props.className,
      width = props.width,
      _props$margin = props.margin,
      margin = _props$margin === void 0 ? '0' : _props$margin,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size;

  var _useStyle = useStyle({
    color: color,
    size: size,
    disabled: disabled,
    width: width,
    margin: margin
  }),
      deleteIconWrapper = _useStyle.deleteIconWrapper,
      chipWrapper = _useStyle.chipWrapper,
      classes = _objectWithoutProperties(_useStyle, _excluded);

  return /*#__PURE__*/_react.default.createElement(_Chip.default, {
    ref: ref,
    "data-testid": props['data-testid'],
    size: size,
    classes: classes,
    className: "".concat(className, " ").concat(chipWrapper),
    id: id !== null && id !== void 0 ? id : label,
    disabled: disabled,
    label: label,
    onClick: onClick,
    onDelete: onDelete,
    clickable: !!onClick,
    deleteIcon: deleteIcon || /*#__PURE__*/_react.default.createElement("div", {
      className: deleteIconWrapper
    }, /*#__PURE__*/_react.default.createElement("svg", {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react.default.createElement("circle", {
      fill: _Colors.default.white,
      opacity: disabled ? '0.7' : '0.3',
      cx: "10",
      cy: "10",
      r: "8"
    }), /*#__PURE__*/_react.default.createElement("path", {
      fill: disabled ? _Colors.default.secondaryGrey : _Colors.default.white,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.24239 10L6.40691 7.16452C6.1977 6.95531 6.1977 6.61612 6.40691 6.40691C6.61612 6.1977 6.95531 6.1977 7.16452 6.40691L10 9.24239L12.8355 6.40691C13.0447 6.1977 13.3839 6.1977 13.5931 6.40691C13.8023 6.61612 13.8023 6.95531 13.5931 7.16452L10.7576 10L13.5931 12.8355C13.8023 13.0447 13.8023 13.3839 13.5931 13.5931C13.3839 13.8023 13.0447 13.8023 12.8355 13.5931L10 10.7576L7.16452 13.5931C6.95531 13.8023 6.61612 13.8023 6.40691 13.5931C6.1977 13.3839 6.1977 13.0447 6.40691 12.8355L9.24239 10Z"
    })))
  });
});

var _default = Chip;
exports.default = _default;